import { Component, computed, ElementRef, inject, OnDestroy, ViewChild } from '@angular/core';
import { AppMenu } from './app.menu';
import { AppMenuProfile } from '@/core/layout/components/app.menuprofile';
import { CommonModule } from '@angular/common';
import { LayoutService } from '@/core/layout/service/layout.service';

@Component({
  selector: '[app-sidebar]',
  standalone: true,
  imports: [AppMenuProfile, AppMenu, CommonModule],
  template: `
    <div class="layout-sidebar" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
      <div class="layout-sidebar-top">
        <a href="/" class="logo-container">
          <img src="/envolve/logo.png" alt="Envolve" class="logo-image" />
          <span class="logo-text">Envolve</span>
        </a>
        <button class="layout-sidebar-anchor" type="button" (click)="anchor()"></button>
      </div>
      <div app-menu-profile #menuProfileStart *ngIf="menuProfilePosition() === 'start'"></div>
      <div #menuContainer class="layout-menu-container">
        <div app-menu></div>
      </div>
      <div app-menu-profile #menuProfileEnd *ngIf="menuProfilePosition() === 'end'"></div>
    </div>
  `,
  styles: `
    // :host ::ng-deep .p-overlaybadge .p-badge {
    //   outline-width: 0px;
    // }

    .layout-topbar-logo {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      padding: 0.5rem 1rem;
    }

    .logo-container {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      text-decoration: none;
    }

    .logo-image {
      height: 32px;
      width: auto;
      object-fit: contain;
    }

    .logo-text {
      font-size: 1.5rem;
      font-weight: 600;
      color: #fff;
      letter-spacing: -0.025em;
      display: none;
      line-height: 1;
    }

    :host-context(.layout-sidebar-active) .logo-text {
      display: inline;
    }

    @media (max-width: 768px) {
      .logo-text {
        display: none;
      }

      .logo-image {
        height: 28px;
      }
    }
  `,
})
export class AppSidebar implements OnDestroy {
  el = inject(ElementRef);

  layoutService = inject(LayoutService);

  @ViewChild(AppMenu) appMenu!: AppMenu;

  @ViewChild('menuProfileStart') menuProfileStart!: AppMenuProfile;

  @ViewChild('menuProfileEnd') menuProfileEnd!: AppMenuProfile;

  @ViewChild('menuContainer') menuContainer!: ElementRef;

  overlayMenuActive = computed(() => this.layoutService.layoutState().overlayMenuActive);

  menuProfilePosition = computed(() => this.layoutService.layoutConfig().menuProfilePosition);

  anchored = computed(() => this.layoutService.layoutState().anchored);

  timeout: any;

  resetOverlay() {
    if (this.overlayMenuActive()) {
      this.layoutService.layoutState.update((val) => ({
        ...val,
        overlayMenuActive: false,
      }));
    }
  }

  onMouseEnter() {
    if (!this.anchored()) {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }
      this.layoutService.layoutState.update((val) => ({
        ...val,
        sidebarActive: true,
      }));
    }
  }

  onMouseLeave() {
    if (!this.anchored()) {
      if (!this.timeout) {
        this.timeout = setTimeout(
          () =>
            this.layoutService.layoutState.update((val) => ({
              ...val,
              sidebarActive: false,
            })),
          300
        );
      }
    }
  }

  anchor() {
    this.layoutService.layoutState.update((val) => ({
      ...val,
      anchored: !val.anchored,
    }));
  }

  ngOnDestroy() {
    this.resetOverlay();
  }
}
